import { render } from "./ReviewFood.vue?vue&type=template&id=23b89c1f&scoped=true"
import script from "./ReviewFood.vue?vue&type=script&lang=js"
export * from "./ReviewFood.vue?vue&type=script&lang=js"

import "./ReviewFood.vue?vue&type=style&index=0&id=23b89c1f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/my_res/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b89c1f"]])

export default __exports__